module.exports = __webpack_public_path__ + "media/images/builder/empty_search-233f017602bac1318c8f1e35bf0524fb.png";